import { MerchantDetails } from '@repo/api/endpoints/merchant';

import { Persons } from '@/components/loan-offer-data-process/form/form.schema';

export const representativeDefaultValues = (merchantDetails: MerchantDetails) => ({
  phone: merchantDetails.phone,
  email: merchantDetails.email,
  address: {
    street: '',
    postCode: '',
    city: '',
    country: '',
  },
  isRepresentative: true,
  isBeneficient: true,
  shares: (Math.round(100 * 100) / 100).toString(),
});

export const liberisDefaultPersonData = (merchantDetails: MerchantDetails) => {
  const personMap = new Map<string, Persons[number]>();
  const commonRepresentative = representativeDefaultValues(merchantDetails);

  merchantDetails.representative.forEach((rep) => {
    personMap.set(rep.pesel, {
      ...commonRepresentative,
      email: '',
      name: `${rep.name} ${rep.surname}`,
      shares: '0',
      isRepresentative: true,
      isBeneficient: false,
      pesel: rep.pesel,
    });
  });

  for (const ben of merchantDetails.beneficiary) {
    const existing = personMap.get(ben.pesel);
    if (existing) {
      existing.isBeneficient = true;
      existing.shares = (
        Math.round((100 / merchantDetails.beneficiary.length) * 100) / 100
      ).toString();
    } else {
      personMap.set(ben.pesel, {
        ...commonRepresentative,
        email: '',
        name: ben.name,
        shares: (Math.round((100 / merchantDetails.beneficiary.length) * 100) / 100).toString(),
        isRepresentative: false,
        isBeneficient: true,
        pesel: ben.pesel,
      });
    }
  }

  const sortedPersons = Array.from(personMap.values()).sort((a, b) => {
    if (a.isRepresentative && !a.isBeneficient) return -1;
    if (b.isRepresentative && !b.isBeneficient) return 1;
    if (a.isRepresentative && a.isBeneficient) return -1;
    if (b.isRepresentative && b.isBeneficient) return 1;

    return 0;
  });

  if (sortedPersons.length > 0) {
    sortedPersons[0].email = commonRepresentative.email;
  }

  return sortedPersons;
};
